// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__kE5hp","itemLink":"style_itemLink__1LQY4","itemCover":"style_itemCover__2twIK"};